
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_w6i3z_13",
  "fit-height": "awsui_fit-height_14iqq_w6i3z_46",
  "with-side-media": "awsui_with-side-media_14iqq_w6i3z_51",
  "variant-default": "awsui_variant-default_14iqq_w6i3z_54",
  "variant-stacked": "awsui_variant-stacked_14iqq_w6i3z_54",
  "refresh": "awsui_refresh_14iqq_w6i3z_63",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_w6i3z_113",
  "with-stuck-sticky-header-at-bottom": "awsui_with-stuck-sticky-header-at-bottom_14iqq_w6i3z_119",
  "focus-ring": "awsui_focus-ring_14iqq_w6i3z_126",
  "with-top-media": "awsui_with-top-media_14iqq_w6i3z_150",
  "content-wrapper": "awsui_content-wrapper_14iqq_w6i3z_155",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_w6i3z_160",
  "media": "awsui_media_14iqq_w6i3z_167",
  "media-top": "awsui_media-top_14iqq_w6i3z_185",
  "media-side": "awsui_media-side_14iqq_w6i3z_190",
  "header": "awsui_header_14iqq_w6i3z_196",
  "header-full-page": "awsui_header-full-page_14iqq_w6i3z_201",
  "header-variant-embedded": "awsui_header-variant-embedded_14iqq_w6i3z_204",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_w6i3z_204",
  "header-with-media": "awsui_header-with-media_14iqq_w6i3z_207",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_w6i3z_213",
  "header-stuck": "awsui_header-stuck_14iqq_w6i3z_223",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_w6i3z_233",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_w6i3z_236",
  "with-paddings": "awsui_with-paddings_14iqq_w6i3z_242",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_w6i3z_251",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_w6i3z_309",
  "header-cover": "awsui_header-cover_14iqq_w6i3z_312",
  "content": "awsui_content_14iqq_w6i3z_155",
  "content-fit-height": "awsui_content-fit-height_14iqq_w6i3z_340",
  "content-inner": "awsui_content-inner_14iqq_w6i3z_346",
  "with-header": "awsui_with-header_14iqq_w6i3z_353",
  "footer": "awsui_footer_14iqq_w6i3z_357",
  "with-divider": "awsui_with-divider_14iqq_w6i3z_361"
};
  